export default {
  en: {
    'login.components.back-to-login.label': 'Login',
  },
};
